__turbopack_context__.v({
  "clusterLabel": "style-module-scss-module__kFIFsW__clusterLabel",
  "loadingContainer": "style-module-scss-module__kFIFsW__loadingContainer",
  "loadingIcon": "style-module-scss-module__kFIFsW__loadingIcon",
  "mapContainer": "style-module-scss-module__kFIFsW__mapContainer",
  "mapErrorContainer": "style-module-scss-module__kFIFsW__mapErrorContainer",
  "mapErrorDescription": "style-module-scss-module__kFIFsW__mapErrorDescription",
  "mapErrorTitle": "style-module-scss-module__kFIFsW__mapErrorTitle",
});
